type LoggerArgs = unknown[];

const debug = (label: string, ...args: LoggerArgs): void => {
  if (import.meta.env.VITE_APP_ENV !== "production") console.debug(`[${label}]`, ...args);
};

const log = (label: string, ...args: LoggerArgs): void => {
  if (import.meta.env.VITE_APP_ENV !== "production") console.log(`[${label}]`, ...args);
};

const warn = (label: string, ...args: LoggerArgs): void => {
  if (import.meta.env.VITE_APP_ENV !== "production") console.warn(`[${label}]`, ...args);
};

const logError = (label: string, ...args: LoggerArgs): void => {
  if (import.meta.env.VITE_APP_ENV !== "production") console.error(`[${label}]`, ...args);
};

export { debug, log, warn, logError };
